<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :append-to-body="appendToBody"
    :custom-class="customClass"
    :close-on-click-modal="closeOnClickModal"
    :destroy-on-close="destroyOnClose"
    :width="width"
    @close="onClose"
    v-bind="$attrs"
    v-on="$listeners"
    v-dialogDrag
  >
    <template v-if="$slots.title" slot="title">
      <slot name="title"></slot>
    </template>
    <!--  title + icon-->
    <div v-else slot="title" class="dialog-title">
      <i v-if="titleIconName" :class="titleIconName"></i>
      {{ title }}
    </div>
    <slot></slot>
    <!-- 底部 -->
    <div v-if="showFooter" slot="footer" class="dialog-footer">
      <el-button
        v-if="showClose"
        @click="onClose"
        :type="!showConfirm ? 'primary' : 'default'"
        >{{ !showConfirm ? "关 闭" : cancelLabel }}</el-button
      >
      <el-button :loading="loading" v-if="showConfirm" type="primary" @click="onConfirm">{{
        confirmLabel
      }}</el-button>
    </div>
    <template v-if="!showFooter && $slots.footer" slot="footer">
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>
<script>
/** 公共弹窗组件 */
export default {
  name: "CbDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    titleIconName: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "800",
    },
    showFooter: {
      type: Boolean,
      default: false, // 大部分dialog不需要footer
    },
    customClass: {
      type: String,
      default: "cb-dialog",
    },
    confirmLabel: {
      type: String,
      default: "确 定",
    },
    cancelLabel: {
      type: String,
      default: "取 消",
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    // false 时 取消按钮显示-- 关闭
    showConfirm: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFormVisible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      this.dialogFormVisible = val;
    },
  },
  methods: {
    onClose() {
      this.$emit("update:dialogVisible", false);
      this.$emit("close");
    },
    onConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/CbDialog.vue